import { render, staticRenderFns } from "./404.vue?vue&type=template&id=a1e40950&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=a1e40950&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e40950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1e40950')) {
      api.createRecord('a1e40950', component.options)
    } else {
      api.reload('a1e40950', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=a1e40950&scoped=true", function () {
      api.rerender('a1e40950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/404.vue"
export default component.exports